goog.provide("shadow.js.shim.module$$mui$material$CssBaseline$default");
shadow.js.shim.module$$mui$material$CssBaseline$default = shadow.js.require(314, {})["default"];
